// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"e536de9f","213":"6a6488d6","455":"e0cabc38","488":"2e5147e5","806":"6a38152f"}[chunkId] + ".chunk.js";
};